/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import * as _ from "lodash";
import { Badge, Grid, Avatar, Typography } from "@mui/material";

import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(4)};
  border-right: 1px solid rgba(0, 0, 0, 0.12);
`;

const FooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
`;

const FooterSubText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: 0.7rem;
  display: block;
  padding: 1px;
`;

const FooterBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)};
  span {
    background-color: ${(props) =>
      props.theme.sidebar.footer.online.background};
    border: 1.5px solid ${(props) => props.theme.palette.common.white};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const sendRequests = async (url, setUrl, company) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let u = "";
    if (authData?.type === "customer_user") {
      u = `/api/v1/${authData?.type}/${company}/media/${url.document_storage_info.key}`;
    } else {
      u = `/api/v1/${authData?.type}/media/${url.document_storage_info.key}`;
    }
    fetch(u, {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
      method: "GET",
    }).then(async (res) => {
      const myFile = await res.blob();
      const u = window.URL.createObjectURL(myFile);
      setUrl(u);
    });
  } catch (e) {
    console.log(e);
  }
};

const SidebarFooter = ({ auths, ...rest }) => {
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [url, setUrl] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (authData?.type !== "super_admin") {
      auths?.user?.documents.map((doc) => {
        if (doc.document_title === "profile_picture") {
          sendRequests(doc, setUrl, auths?.user?.customer_company?._id);
        }
      });
    }
  }, [auths?.user]);
  return (
    <Footer {...rest}>
      <Grid
        container
        spacing={2}
        style={{ cursor: "pointer", width: "fit-content" }}
        onClick={() => {
          navigate("/profile/my");
        }}
      >
        <Grid item>
          <FooterBadge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <Avatar
              alt="User"
              src={
                authData?.type === "super_admin"
                  ? "/static/img/avatars/icon.png"
                  : url
              }
            />
          </FooterBadge>
        </Grid>
        <Grid item>
          <FooterText variant="body2">{auths?.user?.name}</FooterText>
          <FooterSubText variant="caption">
            {authData?.type !== "super_admin"
              ? _.upperCase(auths?.user?.role?.role_name)
              : "SUPER ADMIN"}
          </FooterSubText>
        </Grid>
      </Grid>
    </Footer>
  );
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(SidebarFooter);
